import { useTranslation } from 'react-i18next';
import { CardV2 } from "../../../components/CardV2/CardV2";

interface CommissionSettingsSectionProps {
  contractTemplate: any;
  updateContractTemplate: (value: any) => void;
}

export default function CommissionSettingsSection({ contractTemplate, updateContractTemplate }: CommissionSettingsSectionProps) {
  const { t } = useTranslation();

  return (
    <CardV2>
      <div className="p-4 space-y-6">
        <div>
          <label className="block mb-2 font-medium">{t('commission_contract_template.sale_duration_label')}</label>
          <div className="text-xs text-muted-foreground mb-2">{t('commission_contract_template.sale_duration_hint')}</div>
          <input
            type="number"
            className="w-32 border rounded p-2"
            value={contractTemplate.saleDuration}
            onChange={e => updateContractTemplate({ saleDuration: Number(e.target.value) })}
          />
        </div>

        <div>
          <label className="block mb-2 font-medium">{t('commission_contract_template.commission_split_label')}</label>
          <div className="text-xs text-muted-foreground mb-2">{t('commission_contract_template.commission_split_hint')}</div>
          <div className="flex items-center gap-4 mb-2">
            <div className="flex flex-col items-start">
              <span className="text-sm mb-1">{t('commission_contract_template.salon_percentage_label')}</span>
              <input
                type="number"
                min={0}
                max={100}
                className="w-24 border rounded p-2"
                value={contractTemplate.salonSplitPercentage ?? 20}
                onChange={e => {
                  const value = Math.max(0, Math.min(100, Number(e.target.value)));
                  updateContractTemplate({
                    salonSplitPercentage: value,
                    brideSplitPercentage: 100 - value,
                  });
                }}
              />
            </div>
            <div className="flex flex-col items-start">
              <span className="text-sm mb-1">{t('commission_contract_template.bride_percentage_label')}</span>
              <input
                type="number"
                min={0}
                max={100}
                className="w-24 border rounded p-2"
                value={contractTemplate.brideSplitPercentage ?? 80}
                onChange={e => {
                  const value = Math.max(0, Math.min(100, Number(e.target.value)));
                  updateContractTemplate({
                    brideSplitPercentage: value,
                    salonSplitPercentage: 100 - value,
                  });
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </CardV2>
  );
}
